export default __webpack_public_path__ + "static/media/device-NEM-128x128.8bb96dec.png";